import React from 'react';
import './PageLoading.css';

function PageLoading() {
  return (
    <div className="page-loading">
      <div className="aperture-overlay">
        <div className="aperture-circle"></div>
      </div>
      <div className="loading-logo">
        <img src="https://i.postimg.cc/hGCKfCwZ/Nouveau-projet.png" alt="Instaloc Logo" />
      </div>
    </div>
  );
}

export default PageLoading;
